import type { ReactNode } from "react";
import { Panel, PanelHead } from "./Panel";

/**
 * A titled panel over a list — the Comments and Activity sections on both
 * request screens. Renders the count in the head, the empty copy when there
 * is nothing, and an optional footer (the comment composer). `ordered` makes
 * the list an <ol>, which the timeline is.
 */
export function ListPanel<T extends { id: string }>({
  id,
  title,
  items,
  renderItem,
  emptyText,
  footer,
  ordered = false,
}: {
  id: string;
  title: string;
  items: T[];
  renderItem: (item: T) => ReactNode;
  emptyText?: string;
  footer?: ReactNode;
  ordered?: boolean;
}) {
  const body = items.length === 0 && emptyText ? <p className="py-3 text-sm text-[var(--text-2)]">{emptyText}</p> : items.map(renderItem);
  return (
    <Panel labelledBy={id}>
      <PanelHead id={id} title={title} count={items.length} />
      {ordered ? <ol className="px-4 py-2">{body}</ol> : <div className="px-4 py-2">{body}</div>}
      {footer}
    </Panel>
  );
}
